import { useExteriorSectionData } from '../useExteriorSection';
import { useLevel1SectionData } from '../useLevel1Section';

export const useLevel2ExteriorSections = () => {
  const { subSections } = useExteriorSectionData('exterior');
  const { subSections: interiorSections } = useLevel1SectionData('interior_questions');
  const exteriorPaint = subSections.exterior_paint;
  const windshield = interiorSections.windshield;

  return [windshield, exteriorPaint].filter(Boolean);
};
